(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VideoGallerySDK", [], factory);
	else if(typeof exports === 'object')
		exports["VideoGallerySDK"] = factory();
	else
		root["VideoGallerySDK"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static.parastorage.com/services/video-gallery-sdk/1.489.0/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!*****************************************!*\
  !*** ../node_modules/nanoajax/index.js ***!
  \*****************************************/
/*! no static exports found */
/*! exports used: ajax */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Best place to find information on XHR features is:
// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest

var reqfields = [
  'responseType', 'withCredentials', 'timeout', 'onprogress'
]

// Simple and small ajax function
// Takes a parameters object and a callback function
// Parameters:
//  - url: string, required
//  - headers: object of `{header_name: header_value, ...}`
//  - body:
//      + string (sets content type to 'application/x-www-form-urlencoded' if not set in headers)
//      + FormData (doesn't set content type so that browser will set as appropriate)
//  - method: 'GET', 'POST', etc. Defaults to 'GET' or 'POST' based on body
//  - cors: If your using cross-origin, you will need this true for IE8-9
//
// The following parameters are passed onto the xhr object.
// IMPORTANT NOTE: The caller is responsible for compatibility checking.
//  - responseType: string, various compatability, see xhr docs for enum options
//  - withCredentials: boolean, IE10+, CORS only
//  - timeout: long, ms timeout, IE8+
//  - onprogress: callback, IE10+
//
// Callback function prototype:
//  - statusCode from request
//  - response
//    + if responseType set and supported by browser, this is an object of some type (see docs)
//    + otherwise if request completed, this is the string text of the response
//    + if request is aborted, this is "Abort"
//    + if request times out, this is "Timeout"
//    + if request errors before completing (probably a CORS issue), this is "Error"
//  - request object
//
// Returns the request object. So you can call .abort() or other methods
//
// DEPRECATIONS:
//  - Passing a string instead of the params object has been removed!
//
exports.ajax = function (params, callback) {
  // Any variable used more than once is var'd here because
  // minification will munge the variables whereas it can't munge
  // the object access.
  var headers = params.headers || {}
    , body = params.body
    , method = params.method || (body ? 'POST' : 'GET')
    , called = false

  var req = getRequest(params.cors)

  function cb(statusCode, responseText) {
    return function () {
      if (!called) {
        callback(req.status === undefined ? statusCode : req.status,
                 req.status === 0 ? "Error" : (req.response || req.responseText || responseText),
                 req)
        called = true
      }
    }
  }

  req.open(method, params.url, true)

  var success = req.onload = cb(200)
  req.onreadystatechange = function () {
    if (req.readyState === 4) success()
  }
  req.onerror = cb(null, 'Error')
  req.ontimeout = cb(null, 'Timeout')
  req.onabort = cb(null, 'Abort')

  if (body) {
    setDefault(headers, 'X-Requested-With', 'XMLHttpRequest')

    if (!global.FormData || !(body instanceof global.FormData)) {
      setDefault(headers, 'Content-Type', 'application/x-www-form-urlencoded')
    }
  }

  for (var i = 0, len = reqfields.length, field; i < len; i++) {
    field = reqfields[i]
    if (params[field] !== undefined)
      req[field] = params[field]
  }

  for (var field in headers)
    req.setRequestHeader(field, headers[field])

  req.send(body)

  return req
}

function getRequest(cors) {
  // XDomainRequest is only way to do CORS in IE 8 and 9
  // But XDomainRequest isn't standards-compatible
  // Notably, it doesn't allow cookies to be sent or set by servers
  // IE 10+ is standards-compatible in its XMLHttpRequest
  // but IE 10 can still have an XDomainRequest object, so we don't want to use it
  if (cors && global.XDomainRequest && !/MSIE 1/.test(navigator.userAgent))
    return new XDomainRequest
  if (global.XMLHttpRequest)
    return new XMLHttpRequest
}

function setDefault(obj, key, value) {
  obj[key] = obj[key] || value
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ 2)))

/***/ }),
/* 1 */
/*!******************!*\
  !*** ./index.ts ***!
  \******************/
/*! exports provided: getInfo, getVideoURLs, getVideoMetadata, getVideoId, getVideoImage */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is an entry point */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInfo", function() { return getInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVideoURLs", function() { return getVideoURLs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVideoMetadata", function() { return getVideoMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVideoId", function() { return getVideoId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVideoImage", function() { return getVideoImage; });
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! nanoajax */ 0);
/* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(nanoajax__WEBPACK_IMPORTED_MODULE_0__);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

var FILE_INFO_URL = 'https://files.wix.com/';
var VIDEO_HOSTING_URL = 'https://video.wixstatic.com/';
var FILE_HOSTING_ULR = 'https://files.wixstatic.com/';
var STATIC_HOSTING_URL = 'https://static.wixstatic.com/';
var VIDEO_ID_REGEX = /([0-9A-Za-z_]+)/;
var getAdaptiveSource = function (adaptiveInfo) {
    if (adaptiveInfo === void 0) { adaptiveInfo = []; }
    return adaptiveInfo.map(function (info) { return ({
        type: info.format.toUpperCase(),
        quality: 'ADAPTIVE',
        url: "" + FILE_HOSTING_ULR + info.url,
    }); });
};
var getProgressiveSource = function (videoInfo) {
    if (videoInfo === void 0) { videoInfo = []; }
    return videoInfo.map(function (info) { return ({
        type: info.format.toUpperCase(),
        quality: info.quality,
        url: "" + VIDEO_HOSTING_URL + info.url,
    }); });
};
/**
 * Get file id from the fileUrl
 * @param fileUrl - File URL according to media gallery format
 * @doc API
 *
 * @example
 * VideoGallerySDK.getVideoId('video/80c05f_b9cca205d9324e56b2ddbd5a90ddb495/file');
 *
 * // Response example:
 * '80c05f_b9cca205d9324e56b2ddbd5a90ddb495'
 */
var getVideoId = function (fileUrl) {
    var splitedUrl = fileUrl.split('/');
    // Check if already truncated ID was passed
    if (splitedUrl.length === 1) {
        if (VIDEO_ID_REGEX.test(splitedUrl[0])) {
            return splitedUrl[0];
        }
        //tslint:disable-next-line
        console.error('Wrong format was passed to VideoGallerySDK.getVideoId');
        return fileUrl;
    }
    if (VIDEO_ID_REGEX.test(splitedUrl[1])) {
        return splitedUrl[1];
    }
    //tslint:disable-next-line
    console.error('Wrong format was passed to VideoGallerySDK.getVideoId');
    return fileUrl;
};
/**
 * Get full info about video item
 * @param id - id or fileUrl of video item
 * @returns Promise that would be resolved with full info about requested video item
 * @doc API
 *
 * @example
 * const id = '80c05f_b9cca205d9324e56b2ddbd5a90ddb495';
 * VideoGallerySDK.getInfo(id).then(info => {
 *   console.log(info);
 * });
 *
 * // Response example:
 * {
 *   file_input: { ... },
 *   file_name: 'file'
 *   file_output: { ... },
 *   file_size: 1267245,
 *   media_type: 'video',
 *   op_status: 'READY',
 *   original_file_name: 'file.mp4',
 *   title: 'file'
 * }
 */
var getInfo = function (id) {
    id = getVideoId(id);
    return new Promise(function (resolve, reject) {
        Object(nanoajax__WEBPACK_IMPORTED_MODULE_0__["ajax"])({
            url: FILE_INFO_URL + "site/media/files/" + id + "/info",
        }, function (statusCode, response) {
            if (statusCode === 200) {
                resolve(JSON.parse(response));
            }
            else {
                reject({
                    statusCode: statusCode,
                    response: response,
                });
            }
        });
    });
};
/**
 * Get video item urls
 * @doc API
 * @param id - id or fileUrl of video item
 * @returns Promise that would be resolved with urls of requested video item
 *
 * @example
 * const id = '80c05f_b9cca205d9324e56b2ddbd5a90ddb495';
 * const player = Playable.create();
 * VideoGallerySDK.getVideoURLs(id).then(urls => {
 *   player.setSrc(urls);
 * });
 *
 * // Response example:
 * [{
 *   type: "HLS",
 *   quality: "ADAPTIVE"
 *   url: "//video.wixstatic.com/video/80c05f_b9cca205d9324e56b2ddbd5a90ddb495/repackage/hls"
 * }, {
 *   type: "MP4",
 *   quality: "480p"
 *   url: "//video.wixstatic.com/video/80c05f_b9cca205d9324e56b2ddbd5a90ddb495/480p/mp4/file.mp4"
 * }]
 *
 * @note
 * Format of answer is fully compatible with [Playable](https://wix.github.io/playable/)
 */
var getVideoURLs = function (idOrInfo) {
    var promise = typeof idOrInfo === 'object'
        ? Promise.resolve(idOrInfo)
        : getInfo(idOrInfo);
    return promise.then(function (info) { return __spreadArrays(getProgressiveSource(info.file_output.video), getAdaptiveSource(info.file_output.adaptive_video)); });
};
/**
 * Get metadata for video item
 * @param id - id or fileUrl of video item
 * @returns Promise that would be resolved with metadata of requested video item
 * @doc API
 *
 * @example
 * const id = '80c05f_b9cca205d9324e56b2ddbd5a90ddb495';
 * VideoGallerySDK.getVideoMetadata(id).then(metadata => {
 *   console.log(metadata.duration);
 * });
 *
 * // Response example:
 * {
 *   "audio_bitrate": 1000,
 *   "display_aspect_ratio": "16:9",
 *   "duration": 94,
 *   "fps": 30,
 *   "height": 720,
 *   "rotation": 0,
 *   "sample_aspect_ratio": "0:0",
 *   "type": "video",
 *   "video_bitrate": 1000,
 *   "width": "1080",
 *   "size": 3000
 * }
 */
var getVideoMetadata = function (idOrInfo) {
    var promise = typeof idOrInfo === 'object'
        ? Promise.resolve(idOrInfo)
        : getInfo(idOrInfo);
    return promise.then(function (info) { return (__assign(__assign({}, info.file_input), { size: info.file_size })); });
};
/**
 * Get link for video image preview. You can get on of 4 created images.
 * @doc API
 * @param id - id or fileUrl of video item
 * @param options - Options for image output
 *
 * @example
 * VideoGallerySDK.getVideoImage('video/80c05f_b9cca205d9324e56b2ddbd5a90ddb495/file', {
 *   previewIndex: 0, // index in range 0..3, one of the frame of video
 *   resizeType: 'fit', // use `fill`, `fit`, `canvas` or `crop`
 *   width: 700,
 *   height: 500,
 *   quality: 100,
 * });
 *
 * // Response example:
 * '//static.wixstatic.com/media/80c05f_b9cca205d9324e56b2ddbd5a90ddb495f000.jpg/v1/fit/w_700,h_500,al_c,q_100/image.jpg'
 */
var getVideoImage = function (id, options) {
    var _a = options.previewIndex, previewIndex = _a === void 0 ? 0 : _a, _b = options.resizeType, resizeType = _b === void 0 ? 'fill' : _b, _c = options.quality, quality = _c === void 0 ? 85 : _c, width = options.width, height = options.height;
    return STATIC_HOSTING_URL + "media/" + getVideoId(id) + "f00" + previewIndex + ".jpg/v1/" + resizeType + "/w_" + width + ",h_" + height + ",al_c,q_" + quality + "/image.jpg";
};



/***/ }),
/* 2 */
/*!*************************************************!*\
  !*** ../node_modules/webpack/buildin/global.js ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })
/******/ ]);
});
//# sourceMappingURL=video-gallery-sdk.bundle.js.map